import React from 'react';
import PropTypes from 'prop-types';

import { trackV2 } from 'utils/analytics';
import I18n from 'utils/I18n';

import { checkoutUrl } from '../../helpers.js';
import styles from './index.scss';

const handleContinueClick = () => {
  trackV2({
    category: 'summit_upsell',
    page: 'checkout',
    action: 'continue_to_billing'
  });
};

const PreCheckoutBanner = ({
  option,
  trialInfo,
  mobileImage,
  desktopImage,
  text
}) => {
  const baseClassName = trialInfo
    ? `${styles.banner} ${styles.trial}`
    : styles.banner;

  const bannerContent = () => {
    return (
      <div className="container">
        <div className={styles.branding}>
          <div className="branding logo-wh logo-xs">
            <span className="sr-only">Strava</span>
          </div>
        </div>
        <div className="col-sm-8 col-xs-12">
          <h1 className={styles.headline1}>{text}</h1>
          {trialInfo && (
            <a
              href={checkoutUrl(option.packageIds, trialInfo)}
              className="btn btn-primary"
              onClick={handleContinueClick()}
              data-test="banner-trial-cta"
            >
              {I18n.t('strava.premium.package_select.banner.cta_trial', {
                days: trialInfo.trialLength
              })}
            </a>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={`${baseClassName} ${styles.desktop}`}
        style={{ 'background-image': `url(${desktopImage}?q=50)` }}
      >
        {bannerContent()}
      </div>
      <div
        className={`${baseClassName} ${styles.mobile}`}
        style={{ 'background-image': `url(${mobileImage}?q=50)` }}
      >
        {bannerContent()}
      </div>
    </>
  );
};

PreCheckoutBanner.defaultProps = {
  trialInfo: null
};

PreCheckoutBanner.propTypes = {
  option: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    priceWithDiscount: PropTypes.number.isRequired,
    packageIds: PropTypes.arrayOf(PropTypes.number).isRequired
  }).isRequired,
  trialInfo: PropTypes.shape({
    trialLength: PropTypes.number
  }),
  mobileImage: PropTypes.string.isRequired,
  desktopImage: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default PreCheckoutBanner;
